import React from 'react';
import { useTranslation } from 'react-i18next';

import FigoLottie from '../../common/FigoLottie';
import successCheckIcon from '../../../assets/petDemos/done-success.svg';
import { ReactComponent as ChevronIcon } from
  '../../../assets/chevron-white.svg';

import styles from './SubmitSuccess.module.css';

const SubmitSuccess = ({ loading = false, onContinuePress = () => { } }) => {
  const { t } = useTranslation('petDemos');

  return (
    <div className={styles.mainContainer}>
      <img alt="Success Check Icon" src={successCheckIcon} />

      <h1>{t('submitSuccess.title')}</h1>

      <p className={styles.description}>
        {t('submitSuccess.description')}
      </p>

      <p className={styles.processingNote}>
        {t('submitSuccess.processingNote')}
      </p>

      <button
        className={styles.continueButton}
        disabled={loading}
        onClick={onContinuePress}
        type="button"
      >
        {loading ? <FigoLottie height={null} width={20} /> : (
          <>
            {t('submitSuccess.continueButton')}

            <ChevronIcon className={styles.chevronIcon} />
          </>
        )}
      </button>
    </div>
  );
};

export { SubmitSuccess };
